// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer[data-v-9b7e33cc]{padding:40px 0;text-align:center}footer .copy[data-v-9b7e33cc]{font-size:13px;color:#999}", ""]);
// Exports
module.exports = exports;
